import { upperFirst } from 'lodash';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { formatCard } from '../../../../../shared/helpers/formatCard';
import { formatPrice } from '../../../../../shared/helpers/formatPrice';
import {
  Stage,
  Status,
  TenantUpfrontPayment,
} from '../../../../../types/bookings';
import DocumentAttachmentsField from '../../../../DocumentAttachmentsField/DocumentAttachmentsField';
import { StyledDescriptionList } from '../../BookingInformation.styles';
import {
  StyledDDItemsToRecipts,
  StyledFullWidthDLItem,
  StyledFullWidthDLItems,
  StyledLinkToComission,
  StyledWrapper,
} from './BookingTenantPaymentInformation.styles';

interface BookingTenantPaymentInformationProps {
  bookingStage: Stage;
  bookingId: string;
  proposal: number;
  cardNumber: number;
  payment_type: string;
  has_pre_payment: boolean;
  tenant_upfront_payment: TenantUpfrontPayment;
  status: Status;
}

const BookingTenantPaymentInformation = ({
  bookingStage,
  bookingId,
  proposal,
  cardNumber,
  status,
}: BookingTenantPaymentInformationProps) => {
  const { t } = useTranslation(['booking', 'common', 'navigation']);
  const updatePaymentInformationUrl = `${process.env.REACT_APP_SITE_URL}/bookings/change-payment-method/${bookingId}`;

  const showUpfrontReceipt = true;

  const showFirstMonthReceipt = true;

  return (
    <StyledDescriptionList>
      <div>
        <dt>{upperFirst(t('booking:offer'))}</dt>
        <dd>{formatPrice(proposal)}</dd>
      </div>
      <div>
        <StyledWrapper>
          <dt>{upperFirst(t('booking:cardNumber'))}</dt>
          {bookingStage !== Stage.Draft && (
            <dt onClick={() => window.open(updatePaymentInformationUrl)}>
              {upperFirst(t('common:change'))}
            </dt>
          )}
        </StyledWrapper>
        <dd>{formatCard(cardNumber)}</dd>
      </div>
      {status === Status.ACCEPTED &&
        (showFirstMonthReceipt || showUpfrontReceipt) && (
          <StyledFullWidthDLItems>
            <div>
              <dt>{upperFirst(t('booking:paymentInformation'))}</dt>
              <StyledDDItemsToRecipts>
                {showFirstMonthReceipt && (
                  <DocumentAttachmentsField
                    title={upperFirst(t('booking:firstMonthPayment'))}
                    type="first_month_payment_receipt"
                    booking_id={bookingId}
                    available_for="internal"
                  />
                )}
                {showUpfrontReceipt && (
                  <DocumentAttachmentsField
                    title={upperFirst(t('booking:zappyrentFeeReceipt'))}
                    type="upfront_payment_receipt"
                    booking_id={bookingId}
                    available_for="internal"
                  />
                )}
              </StyledDDItemsToRecipts>
            </div>
          </StyledFullWidthDLItems>
        )}
      <StyledFullWidthDLItem>
        <StyledLinkToComission
          href={t('navigation:commisionsAndFees')}
          target="_blank"
          rel="noreferrer"
        >
          {upperFirst(t('booking:commisionsAndFees'))}
          <ExternalLink size={14} aria-hidden="true" />
        </StyledLinkToComission>
      </StyledFullWidthDLItem>
    </StyledDescriptionList>
  );
};

export default BookingTenantPaymentInformation;
